/** The look shared by every form field (inputs, textareas, dropdowns). */
export const inputClass =
  'h-10 w-full rounded-[10px] border border-border bg-bg-2 px-3 text-sm text-fg placeholder:text-fg-disabled transition-colors duration-150 hover:border-fg-3/50 focus:border-lime/60 focus:outline-none focus:ring-2 focus:ring-lime/15 disabled:opacity-50';
